import React from "react";
import { Grid } from "@mui/material";
import PropTypes from "prop-types";
import ProductGroupInput from "../../../CustomProductSelect/ProductGroupInput";
import ProductTypeInput from "../../../CustomProductSelect/ProductTypeInput";
import ProductStatusInput from "../../../CustomProductSelect/ProductStatusInput";
import ProductModelInput from "../../../CustomProductSelect/ProductModelInput";
import ProductColorInput from "../../../CustomProductSelect/ProductColorInput";
import ProductBrandInput from "../../../CustomProductSelect/ProductBrandInput";
import ProductList from "../../../CustomProductSelect/Components/ProductList";

export default function ConditionSelectProduct(props) {
  const { defaultValue } = props;
  const [productMainGroup, setProductMainGroup] = React.useState("");
  const [productType, setProductType] = React.useState("");
  const [sendData, setSendData] = React.useState("");
  const [productBrand, setProductBrand] = React.useState("");
  const [productStatus, setProductStatus] = React.useState("");
  const [productModel, setProductModel] = React.useState("");
  const [productColor, setProductColor] = React.useState("");
  const [productTableData, setProductTableData] = React.useState([]);

  React.useEffect(async () => {
    if (sendData === true) {
      let dataResponse = await {
        productMainGroup:
          typeof productMainGroup !== "undefined" ? productMainGroup : "",
        productType: typeof productType !== "undefined" ? productType : "",
        productBrand: typeof productBrand !== "undefined" ? productBrand : "",
        productStatus:
          typeof productStatus !== "undefined" ? productStatus : "",
        productModel: typeof productModel !== "undefined" ? productModel : "",
        productColor: typeof productColor !== "undefined" ? productColor : "",
        productTableData:
          typeof productTableData !== "undefined" ? productTableData : "",
      };
      await props.result(dataResponse);
      await setSendData(false);
    }
    return () => {};
  }, [sendData]);
  React.useEffect(async () => {
    await console.log("defaultValue", defaultValue);
    await setSendData(false);
    try {
      if (defaultValue) {
        await setProductMainGroup(defaultValue.productMainGroup);
        await setProductType(defaultValue.productType);
        await setProductBrand(defaultValue.productBrand);
        await setProductStatus(defaultValue.productStatus);
        await setProductModel(defaultValue.productModel);
        await setProductColor(defaultValue.productColor);
        await setProductTableData(defaultValue.productTableData);
      }
    } catch (error) {
      console.error();
    }
    return () => {};
  }, [defaultValue]);
  const resultData = async (provenance, value) => {
    if (provenance === "ProductMainGroup") {
      await setProductMainGroup(typeof value === "undefined" ? "" : value);
    }
    if (provenance === "ProductType") {
      await setProductType(typeof value === "undefined" ? "" : value);
    }
    if (provenance === "ProductBrand") {
      await setProductBrand(typeof value === "undefined" ? "" : value);
    }
    if (provenance === "ProductStatus") {
      await setProductStatus(typeof value === "undefined" ? "" : value);
    }
    if (provenance === "ProductModel") {
      await setProductModel(typeof value === "undefined" ? "" : value);
    }
    if (provenance === "ProductColor") {
      await setProductColor(typeof value === "undefined" ? "" : value);
    }
    if (provenance === "ProductList") {
      await setProductTableData(typeof value === "undefined" ? "" : value);
    }
    await setSendData(true);
  };
  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={6} sm={12} md={6} lg={4} xl={3}>
          <ProductGroupInput
            label={"กลุ่ม"}
            resultData={(e) => resultData("ProductMainGroup", e)}
            inputType={"text"}
            keyDown={(e) => keyDown(e)}
            defaultValue={productMainGroup}
          />
        </Grid>
        <Grid item xs={6} sm={12} md={6} lg={4} xl={3}>
          <ProductTypeInput
            label={"ประเภท"}
            resultData={(e) => resultData("ProductType", e)}
            inputType={"text"}
            keyDown={(e) => keyDown(e)}
            defaultValue={productType}
          />
        </Grid>
        <Grid item xs={6} sm={12} md={6} lg={4} xl={3}>
          <ProductBrandInput
            label={"ยี่ห้อ"}
            resultData={(e) => resultData("ProductBrand", e)}
            inputType={"text"}
            keyDown={(e) => keyDown(e)}
            defaultValue={productBrand}
          />
        </Grid>
        <Grid item xs={6} sm={12} md={6} lg={4} xl={3}>
          <ProductStatusInput
            label={"สถานะ"}
            resultData={(e) => resultData("ProductStatus", e)}
            inputType={"text"}
            keyDown={(e) => keyDown(e)}
            defaultValue={productStatus}
          />
        </Grid>
        <Grid item xs={6} sm={12} md={6} lg={4} xl={3}>
          <ProductModelInput
            label={"รุ่น"}
            resultData={(e) => resultData("ProductModel", e)}
            inputType={"text"}
            keyDown={(e) => keyDown(e)}
            defaultValue={productModel}
          />
        </Grid>
        <Grid item xs={6} sm={12} md={6} lg={4} xl={3}>
          <ProductColorInput
            label={"สี"}
            resultData={(e) => resultData("ProductColor", e)}
            inputType={"text"}
            keyDown={(e) => keyDown(e)}
            defaultValue={productColor}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <ProductList
            resultData={(e) => resultData("ProductList", e)}
            defaultValue={productTableData}
          />
        </Grid>
      </Grid>
    </>
  );
}

ConditionSelectProduct.propTypes = {
  defaultValue: PropTypes.array,
};
